module.exports = __webpack_public_path__ + "static/media/icon-gift.719fa252.svg";